import React, { useState, createContext, useEffect } from 'react'

export const contextData = createContext();


const ContextProvider = ({ children }) => {

    const [active, setActive] = useState('tab1');
    const [activeMeetingsSubTab, setActiveMeetingsSubTab] = useState()
    const [activeAuditSubTab, setActiveAuditSubTab] = useState()
    const [viewPastMeeting, setViewPastMeeting] = useState({
        isView: false,
        meetingId: ""
    })
    const [loading, setLoading] = useState(false);
    const [autoLogin, setAutoLogin] = useState(false)
    const [LoggedIn, setLoggedIn] = useState(false);
    const [LoggedMsg, setLoggedMsg] = useState("Logged Out Successfully.");
    const [fromPastMeeting, setFromPastMeeting] = useState('past');
    const [ActiveTBbutton, setActiveTBbutton] = useState(2);
    const [NavFromTBoard, setNavFromTBoard] = useState("navFromTaskBoard");
    //////SESSION EXPIRED POPUP STATES//////////////////
    const [openFailModal, setOpenFailModal] = useState(false);
    const [failMessage, setFailMessage] = useState("");
    const [isProxy, setIsProxy] = useState(null)

    //////////////////////////////////////////////
    return (
        <contextData.Provider value={{
            setActive, isProxy
            , setIsProxy,
            active,
            setViewPastMeeting,
            viewPastMeeting,
            loading,
            setLoading,
            activeMeetingsSubTab,
            setActiveMeetingsSubTab,
            openFailModal,
            setOpenFailModal,
            failMessage,
            setFailMessage,
            activeAuditSubTab,
            setActiveAuditSubTab,
            LoggedIn,
            setLoggedIn,
            LoggedMsg,
            setLoggedMsg,
            fromPastMeeting,
            setFromPastMeeting,
            ActiveTBbutton,
            setActiveTBbutton,
            NavFromTBoard,
            setNavFromTBoard,
            autoLogin,
            setAutoLogin

        }}>
            {children}
        </contextData.Provider>
    )
}

export default ContextProvider